/**
 * Kundenportal für Großunternehmen - Ummeldungs-API
 *
 * Contact: we.it.ikp-team@wienenergie.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const UmmeldungStatus = {
    BEGONNEN: 'BEGONNEN',
    UEBERMITTELT: 'UEBERMITTELT',
    UNTERSCHRIFT_ERFORDERLICH: 'UNTERSCHRIFT_ERFORDERLICH',
    ABGESCHLOSSEN: 'ABGESCHLOSSEN'
} as const;
export type UmmeldungStatus = typeof UmmeldungStatus[keyof typeof UmmeldungStatus];

